import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Typography from '@material-ui/core/Typography'
import ExpandMore from '@material-ui/icons/ExpandMore'

const styles = theme => ({
  root: {},
  title: {
    fontSize: 32,
    color: theme.palette.black,
  },
  label: {
    cursor: 'pointer',
    position: 'relative',
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
    '&:after': {
      left: 0,
      right: 0,
      height: 2,
      bottom: 0,
      content: "''",
      position: 'absolute',
      backgroundColor: theme.palette.primary.main,
    },
  },
  menuItem: {
    fontSize: 16,
    textTransform: 'none',
  },
  content: {
    display: 'flex',
  },
  icon: {
    transition: 'all .2s ease',
  },
  iconFlipped: {
    transform: 'scaleY(-1)',
  },
})

class DropdownSelect extends React.PureComponent {
  state = {
    open: false,
    anchorEl: null,
  };

  handleMenuOpen = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  };

  handleMenuClose = () => {
    this.setState({ open: false })
  };

  handleOptionSelect = (option) => {
    this.handleMenuClose()
    this.props.onChange(option)
  };

  render() {
    const { open, anchorEl } = this.state
    const {
      text, prefix, classes, options, selected, className
    } = this.props

    return (
      <div className={classNames(classes.root, className)}>
        <div className={classes.content}>
          <Typography className={classes.title}>{text}</Typography>
          <div
            id="profile-selector"
            className={classes.content}
            onClick={this.handleMenuOpen}>
            <Typography className={classNames(classes.title, classes.label)}>
              {prefix} {selected.label}
            </Typography>
            <ExpandMore
              color="primary"
              className={classNames(classes.icon, open && classes.iconFlipped)}
            />
          </div>
        </div>
        <Menu
          open={open}
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={this.handleMenuClose}>
          {options.map(option => (
            <MenuItem
              key={option.value}
              classes={{ root: classes.menuItem }}
              onClick={() => this.handleOptionSelect(option)}>
              {prefix} {option.label}
            </MenuItem>
          ))}
        </Menu>
      </div>
    )
  }
}

DropdownSelect.propTypes = {
  text: PropTypes.string,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  options: PropTypes.array,
  classes: PropTypes.object,
  selected: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(DropdownSelect)



// WEBPACK FOOTER //
// ./src/components/molecules/DropdownSelect.js